"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0.999756 0.512939C0.723613 0.512939 0.499756 0.736797 0.499756 1.01294C0.499756 1.28908 0.723613 1.51294 0.999756 1.51294H3.25052L6.12486 10.6828C6.25559 11.0998 6.64202 11.3837 7.07908 11.3837H17.0001C17.2763 11.3837 17.5001 11.1598 17.5001 10.8837C17.5001 10.6075 17.2763 10.3837 17.0001 10.3837H7.07908L6.6655 9.06425H14.8869C15.3274 9.06425 15.7161 8.77596 15.8439 8.35437L17.4475 3.06466C17.6422 2.42245 17.1616 1.77454 16.4905 1.77454H4.3805L4.20474 1.21383C4.07401 0.796779 3.68759 0.512939 3.25052 0.512939H0.999756ZM4.69395 2.77454L6.35205 8.06425H14.8869L16.4905 2.77454H4.69395ZM8.84982 14.5129C9.26293 14.5129 9.59916 14.1776 9.59916 13.7622C9.59916 13.3469 9.26293 13.0115 8.84982 13.0115C8.43671 13.0115 8.10048 13.3469 8.10048 13.7622C8.10048 14.1776 8.43671 14.5129 8.84982 14.5129ZM8.84982 15.5129C9.81595 15.5129 10.5992 14.7291 10.5992 13.7622C10.5992 12.7953 9.81595 12.0115 8.84982 12.0115C7.88368 12.0115 7.10048 12.7953 7.10048 13.7622C7.10048 14.7291 7.88368 15.5129 8.84982 15.5129ZM15.3776 13.7622C15.3776 14.1776 15.0413 14.5129 14.6282 14.5129C14.2151 14.5129 13.8789 14.1776 13.8789 13.7622C13.8789 13.3469 14.2151 13.0115 14.6282 13.0115C15.0413 13.0115 15.3776 13.3469 15.3776 13.7622ZM16.3776 13.7622C16.3776 14.7291 15.5943 15.5129 14.6282 15.5129C13.6621 15.5129 12.8789 14.7291 12.8789 13.7622C12.8789 12.7953 13.6621 12.0115 14.6282 12.0115C15.5943 12.0115 16.3776 12.7953 16.3776 13.7622Z"
}));

exports["default"] = _default;